// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span[data-v-496737ab]{display:block;font-weight:700;color:#200033;text-transform:uppercase;margin-bottom:14px;letter-spacing:1px}", ""]);
// Exports
module.exports = exports;
